import Icon from "@ant-design/icons";

export default function WaterUseIcon(props: any) {
  return (
    <Icon
      component={() => (
        <svg
          width="1em"
          height="1em"
          viewBox="0 0 10 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.09538 2.82674C6.58937 3.86227 7.37031 4.91787 8.17155 6.16919C8.55034 6.76075 8.92451 7.38715 9.20475 8.01229C9.48182 8.63041 9.7041 9.3269 9.7041 10.0474C9.70408 12.6385 7.60374 14.7388 5.0127 14.7388C2.4289 14.7388 0.321315 12.6783 0.321289 10.0474C0.321289 9.32275 0.540596 8.62266 0.817383 7.99862C1.0969 7.36845 1.47014 6.73946 1.84928 6.1464C2.65285 4.88947 3.43193 3.84601 3.93457 2.81698L5.02507 0.583252L6.09538 2.82674ZM5.0127 3.34367C3.92801 5.56432 1.52116 8.08658 1.52116 10.0474C1.52118 12.0083 3.08434 13.539 5.0127 13.539C6.941 13.5389 8.50421 11.9758 8.50423 10.0474C8.50423 8.11908 6.08623 5.59404 5.0127 3.34367Z"
            fill="currentColor"
          />
        </svg>
      )}
      {...props}
    />
  );
}
